import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import CreateObjectActionMetadata from 'automation-ui-action-features/actions/create-object/records/CreateObjectActionMetadata';
import CreateObjectActionDetail from 'automation-ui-action-features/actions/create-object/CreateObjectActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class CreateObjectActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(CreateObjectActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
CreateObjectActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(CreateObjectActionMetadata).isRequired,
  actionLabel: PropTypes.node,
  flowObjectTypeId: ObjectTypeIdType
};
export default CreateObjectActionHistoryCard;